import { getMessageIdFromUrl } from "helpers/inbox/messageQueryParam";
import { useSearchParams } from "react-router";

/**
 * Custom hook to get the selected messageId from URL search params
 *
 * Reads the "selectedMessageId" query parameter from the URL and returns
 * the full messageId in the format "messages/<UUID>"
 *
 * @returns The full messageId (e.g., "messages/abc-123") or empty string if not present
 *
 * @example
 * ```typescript
 * // URL: /customers/123/inbox/my/threads/xyz?selectedMessageId=abc-123
 * const messageId = useSelectedMessageId();
 * // messageId = "messages/abc-123"
 * ```
 */
export function useSelectedMessageId(): string {
  const [searchParams] = useSearchParams();
  return getMessageIdFromUrl(searchParams);
}
